import { render, staticRenderFns } from "./header-layout-cncc.vue?vue&type=template&id=70bd87b1&scoped=true&"
import script from "./header-layout-cncc.vue?vue&type=script&lang=js&"
export * from "./header-layout-cncc.vue?vue&type=script&lang=js&"
import style0 from "./header-layout-cncc.vue?vue&type=style&index=0&id=70bd87b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd87b1",
  null
  
)

export default component.exports